import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VirtualScrollerModule } from 'primeng/virtualscroller';

import { AuthService } from '../auth.service';
import { GestpayService } from '../gestpay.service';
import { SubscriptionService } from '../subscription.service';

import { MenuItem } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { SelectItem } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { Subtype } from '../subtype'

@Component({
  selector: 'app-facegate-subscription',
  templateUrl: './facegate-subscription.component.html',
  styleUrls: ['./facegate-subscription.component.css']
})
export class FacegateSubscriptionComponent implements OnInit {

  public items: MenuItem[];
  public payForm: FormGroup;
  public amount: string;                  // amount to pay
  public transactionID: string;           // ID of the operation

  public subs: SelectItem[];
  public selectedSub: string;

  public display: boolean = false;

  // DISPLAY POPUP
  public displayPopup: boolean;

  public username: string;
  public attivo: string;
  public currentEmployees: string;
  public maxEmployees: string;
  public dataExpire: string;
  public freeEmployees: number;
  public tipo: string;

  public subscriptionType: Subtype[] = []

  constructor(
      private fb: FormBuilder,
      private auth: AuthService,
      private gestpay: GestpayService,
      private router: Router,
      private subscription: SubscriptionService
  ) { }

  ngOnInit() {
    this.loadServicesMenu();
    this.initForm();
    this.loadSubsMenu();
    this.getSubscriptionPay();
    this.loadSubscriptionType();
  }

  initForm() {
    this.payForm = this.fb.group({
      'amount': ['', Validators.required],
      'transactionID': ['', Validators.required],
    });
  }

  loadServicesMenu() {
    this.items = [
      {
        label: 'DATI',
        items: [
          {label: 'I miei dati', icon: 'pi pi-fw pi-file', routerLink: ['/home']},
          {label: 'La mia sottoscrizione', icon: 'pi pi-fw pi-dollar'}
        ]
      },
      {
        label: 'SERVIZI',
        items: [
          {label: 'Registro foto', icon: 'pi pi-fw pi-camera', routerLink: ['/photosFacegate']},
          {label: 'Dati riepilogativi', icon: 'pi pi-fw pi-users', routerLink: ['/reportsFacegate']},
          //{label: 'Configurazione', icon: 'pi pi-fw pi-cog', routerLink: ['/reportConfig']}
        ]
      }
    ];
  } // end loadServicesMenu

  getSubscriptionPay() {

    this.auth.getCurrentSession().subscribe(
      currSess => {
        //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        //console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.username = username;
        this.subscription.getSubscriptionPayData(idToken, username).subscribe(
          data => {
            console.log("Successfull getSubscriptionPayData: data = " + JSON.stringify(data, null, 2));
            if (data.result.active=='Y') this.attivo = "ATTIVO";
            if (data.result.active=='N') this.attivo = "NON ATTIVO"
            if (data.result.active=='V') this.attivo = "DA VALIDARE (completare anagrafica nella sezione <I miei dati>)"
            this.currentEmployees = data.result.currentEmployees;
            this.maxEmployees = data.result.maxEmployees;
            this.tipo = data.result.tipologia;
            if (this.tipo!="free") this.tipo = this.tipo + " utenti"
            let dataArray = data.result.endSubscriptionDate.split(' ');
            //let oraArray = dataArray[4].split(':')
            console.log('dataArray' + dataArray)
            this.dataExpire = dataArray[2] + ' ' + dataArray[1] + ' ' + dataArray[3] /*+ '\xa0\xa0\xa0\xa0\xa0' + oraArray[0]+ ':' + oraArray[1]*/;
            this.freeEmployees = parseInt(this.maxEmployees) - parseInt(this.currentEmployees);
            },
          error => {
            alert("GETSUBSCRIPTIONPAYDATA ERROR");
            console.log("Failed getSubscriptionData: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );

  }

  removeSubscriptionFree(){
    for( let i=0; i<this.subscriptionType.length; i++ ){
      if (this.subscriptionType[i].type_key==="subscription_free"){
        this.subscriptionType.splice(i);
      }
    }
  }

  loadSubscriptionType(){
    this.auth.getCurrentSession().subscribe(
      currSess => {
        //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        this.subscription.getSubscriptionType(idToken).then(
          subscriptionType =>  {this.subscriptionType = subscriptionType;
            this.removeSubscriptionFree();}
        );

        console.log("**** SUB TYPE ****" + JSON.stringify(this.subscriptionType))
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );
  } // end loadFaces

  onSubmitPayClick(price, type_key) {

    const amount = price;
    const transactionID = type_key;

    this.auth.getCurrentSession().subscribe(

      currSess => {
        console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        console.log("IdToken = " + idToken);
        this.gestpay.encrypt(idToken, amount, transactionID).subscribe(
          data => {
            // alert("YOU SUCCESSFULLY PAYED");
            console.log("Successful registration." + "\n" +
            "Payment data: " + JSON.stringify(data, null, 2));

            let gestpayURL = "https://sandbox.gestpay.net/pagam/pagam.aspx?a="+ data.a +"&b=" + data.b;
            console.log("URL DA INVOCARE " + gestpayURL)

            window.open(gestpayURL, "_self")
          },
          error => {
            alert("PAYMENT ERROR");
            console.log("Failed payment: error = " + JSON.stringify(error, null, 2));
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }

    );

  } // end onSubmitPayClick

  onClickSubscribe(i) {
    //console.log(i);
    let subtype = this.subscriptionType[i].type_key;
    let subname = subtype.split('_')
    let subvalue = subname[1];
    console.log('subvalue = ' + subvalue)

    this.auth.getCurrentSession().subscribe(
        currSess => {
          //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
          let idToken = currSess.idToken.jwtToken;
          //console.log("IdToken = " + idToken);
          let username = currSess.accessToken.payload.username;
          this.username = username;
          let timestamp = Date.now();
          this.onSubmitPayClick(this.subscriptionType[i].price, username + "_" + timestamp +  "_" + this.subscriptionType[i].type_key); //AGGIUGI ID UNIVOCO
          this.display = true;
          /*this.subscription.updateSubscriptionType(idToken, username, subvalue).subscribe(
            data => {
              console.log("Successfull updateSubscriptionType: data = " + JSON.stringify(data, null, 2));
              this.getSubscriptionPay();
              let timestamp = Date.now();
              this.onSubmitPayClick(this.subscriptionType[i].price, username + "_" + timestamp +  "_" + this.subscriptionType[i].type_key); //AGGIUGI ID UNIVOCO
              this.display = true;
              },
            error => {
              alert("UPDATESUBSCRIPTIONTYPE ERROR");
              console.log("Failed getSubscriptionData: error = " + JSON.stringify(error, null, 2))
            }
          );*/
        },
        error => {
          alert("GETCURRENTSESSION ERROR");
          console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
        }
      );
  }

  onClickUpdateSubscription() {
    this.displayPopup = true;
  }

  loadSubsMenu(){
    this.subs = [
      {label: '50 IMMAGINI', value: 'subscription_50'},
      {label: '100 IMMAGINI', value: 'subscription_100'}
    ];
  } // end loadSubsMenu

}
